import { OnboardingGuideProvider } from '@/context/OnboardingGuideContext/onboardingGuideContext';
import { Outlet } from 'react-router';

export const OnboardingGuideRoute = () => {
  return (
    <OnboardingGuideProvider>
      <Outlet />
    </OnboardingGuideProvider>
  );
};
